import { createSlice } from "@reduxjs/toolkit";
const authenticationSlice = createSlice({
  name:"authentication",
  initialState:{
    token:"",
    user:{}
  },
  reducers:{
    setToken:(state,action)=>{
      state.token = action.payload
    },
    setUser:(state,action)=>{
      state.user = action.payload
    }
  }
})

export const {setToken,setUser} = authenticationSlice.actions
export default authenticationSlice.reducer